export const boldifyString = (value: string) => `<span class="activity-logs--bold">${value}</span>`;

export const boldifyStringArray = (values: Array<string>) =>
  values.map(value => `<span class="activity-logs--bold">${value}</span>`).join(', ');

export const buildField = (name: string, language: string) =>
  `<span class="activity-logs__field activity-logs__field--${language}">${name}</span>`;
